import { render, staticRenderFns } from "./CompleteIdentification.vue?vue&type=template&id=06471604&"
import script from "./CompleteIdentification.vue?vue&type=script&lang=js&"
export * from "./CompleteIdentification.vue?vue&type=script&lang=js&"
import style0 from "./CompleteIdentification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports